import { Navbar } from "@/components/landing/Navbar";
import { ExploreBanner } from "@/components/landing/ExploreBanner";
import { HeroSection } from "@/components/landing/HeroSection";
import { WhatIsDeltaGreenX } from "@/components/landing/WhatIsDeltaGreenX";
import { AIConfidencePublic } from "@/components/landing/AIConfidencePublic";
import { MarketReality } from "@/components/landing/MarketReality";
import { PainPoints } from "@/components/landing/PainPoints";
import { ValueProp } from "@/components/landing/ValueProp";
import { InvestorTrigger } from "@/components/landing/InvestorTrigger";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { BuyerSection } from "@/components/landing/BuyerSection";
import { SupplierSection } from "@/components/landing/SupplierSection";
import { InvestorTeaser } from "@/components/landing/InvestorTeaser";
import { Exclusivity } from "@/components/landing/Exclusivity";
import { Authority } from "@/components/landing/Authority";
import { FinalClose } from "@/components/landing/FinalClose";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage({ openModal }) {
  return (
    <main className="bg-[#050A07] min-h-screen">
      <ExploreBanner />
      <Navbar openModal={openModal} />
      <HeroSection openModal={openModal} />
      <WhatIsDeltaGreenX />
      <AIConfidencePublic />
      <MarketReality />
      <PainPoints />
      <ValueProp />
      <InvestorTrigger />
      <HowItWorks />
      <BuyerSection openModal={openModal} />
      <SupplierSection openModal={openModal} />
      <InvestorTeaser openModal={openModal} />
      <Exclusivity />
      <Authority />
      <FinalClose openModal={openModal} />
      <Footer />
    </main>
  );
}
